import { isBrowser } from './isBrowser'
import { SCROLL_FIXED_OFFSET } from '../components/containers/Header'

export function isHeaderFixed (leaderboardHeight) {
  return isBrowser()
    ? window.pageYOffset >= leaderboardHeight + SCROLL_FIXED_OFFSET
    : false
}
